import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IReservation, ISuccessMessage, IUser } from '@curbnturf/entities';
import { Observable } from 'rxjs';
import { BASE_API_URL } from '../network/api-config';

const API_URL = BASE_API_URL + 'rating';

/**
 * Local fork of @curbnturf/rating's BanUserService — trimmed to plain
 * HttpClient. Only banGuest() is used; listBansForGuest/unbanGuest are
 * admin-only (curbnturf-admin), not needed here.
 */
@Injectable({ providedIn: 'root' })
export class BanUserApiService {
  private readonly http = inject(HttpClient);

  banGuest(user: IUser, reservation: IReservation): Observable<ISuccessMessage> {
    const guestId = user.id;
    return this.http.post<ISuccessMessage>(`${API_URL}/guest/${guestId}/ban`, {
      id: reservation.id,
    });
  }
}
